export default function PlayerMenuContentProgress() {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="spinner" />
    </div>
  );
}
